import React, { Component } from 'react'
import { Trans } from '@lingui/react'

import Linka from 'client/shared/blocks/linka'
import Spacer from 'client/shared/blocks/spacer'
import urlFor from 'shared/tools/url-helper'
import { CurrentUserState } from 'client/shared/types/current-user'
import { Dispatch } from 'shared/types/redux'
import {
  BookshelfTab,
  BookshelfTopic,
} from 'client/bookmate/pages/shelves-page'

import './shelves-nav.styl'
import cn from 'classnames'
import { QueryParams } from 'shared/tools/url-helper'

type Props = {
  currentUser: CurrentUserState
  topics: BookshelfTopic[]
  dispatch: Dispatch
  tabs?: BookshelfTab
  pathname: string
  query?: QueryParams
}

export class ShelvesNavMobile extends Component<Props> {
  render(): JSX.Element {
    const {
      topics,
      tabs,
      currentUser: { auth },
      pathname,
      query,
    } = this.props

    return (
      <>
        <div className="shelves-topics_mobile">
          <div className="shelves-topics__heading">
            <Trans id="search.by_topic" />
          </div>
          <Spacer size={32} />
          <Linka
            path={urlFor.bookshelves(query)}
            className={cn('shelves-nav_option', {
              tab_active: pathname.includes('all'),
            })}
            onClick={this.openTab}
          >
            <Trans id="auth.all" />
          </Linka>
          {topics?.map(topic => (
            <Linka
              path={urlFor.bookshelvesTopic(`t-${topic.slug}`, query)}
              className={cn('shelves-nav_option', {
                tab_active: pathname.includes(topic.slug),
              })}
              key={topic.uuid}
            >
              {topic.title}
            </Linka>
          ))}
          {tabs?.friends && auth && (
            <Linka
              path={urlFor.bookshelvesTopic('friends', query)}
              className={cn('shelves-nav_option', {
                tab_active: pathname.includes('friends'),
              })}
            >
              <Trans id="feed.friends_feed" />
            </Linka>
          )}
          {tabs?.following && auth && (
            <Linka
              path={urlFor.bookshelvesTopic('following', query)}
              className={cn('shelves-nav_option', {
                tab_active: pathname.includes('following'),
              })}
            >
              <Trans id="profile.own_shelves" />
            </Linka>
          )}
        </div>
      </>
    )
  }
}
